import axios from 'axios'
import buildType from '../../../services/buildType'
import router from '../../../router/index'
import store from '@/store'
import { getMessaging, getToken } from 'firebase/messaging'
export default {
  state: {
    hrsApi: buildType.apiURL('hrs'),
    oAuth: buildType.apiURL('oauth'),
    esanqua: buildType.apiURL('esanqua'),
    build: process.env.VUE_APP_BUILD_TYPE,
    proc: buildType.apiURL('proc'),
    fcmToken: '',
    // notification: 0,
    notification: {
      totalData: 0,
      result: [],
      totalUnread: 0,
      loading: false
    },
    permission: {
      result: [],
      totalData: 0,
      loading: false
    },
    leave: {
      result: [],
      totalData: 0,
      loading: false
    },
    fpb: {
      result: [],
      totalData: 0,
      loading: false
    },
    ca: {
      result: [],
      totalData: 0,
      loading: false
    },
    pjca: {
      result: [],
      totalData: 0,
      loading: false
    },
    rab: {
      result: [],
      totalData: 0,
      loading: false
    },
    overtime: {
      result: [],
      totalData: 0,
      loading: false
    },
    notificationQueue: null,
    notificationQueueIndex: 0
  },
  mutations: {
    setFcmToken(state, payload) {
      state.fcmToken = payload
    },
    setNotificationResult(state, payload) {
      state.notification.result = payload.data
      state.notification.totalData = Number(payload.total_record)

      state.notification.totalUnread = Number(payload.total_unread)
      // state.notification.totalUnread = 0
      // for (let i = 0; i < payload.data.length; i++) {
      //   if (payload.data[i].status === 0) {
      //     ++state.notification.totalUnread
      //   }
      // }

      state.notification.loading = false
    },
    setPermissionApprovalNeedsResult(state, payload) {
      state.permission.result = payload.data
      state.permission.totalData = Number(payload.total_record)
      state.permission.loading = false
    },
    setLeaveApprovalNeedsResult(state, payload) {
      state.leave.result = payload.data
      state.leave.totalData = Number(payload.total_record)
      state.leave.loading = false
    },
    setFpbApprovalNeedsResult(state, payload) {
      state.fpb.result = payload.data
      state.fpb.totalData = Number(payload.total_record)
      state.fpb.loading = false
    },
    setCaApprovalNeedsResult(state, payload) {
      state.ca.result = payload.data
      state.ca.totalData = Number(payload.total_record)
      state.ca.loading = false
    },
    setPjcaApprovalNeedsResult(state, payload) {
      state.pjca.result = payload.data
      state.pjca.totalData = Number(payload.total_record)
      state.pjca.loading = false
    },
    setRabApprovalNeedsResult(state, payload) {
      state.rab.result = payload.data
      state.rab.totalData = Number(payload.total_record)
      state.rab.loading = false
    },
    setOvertimeApprovalNeedsResult(state, payload) {
      state.overtime.result = payload.data
      state.overtime.totalData = Number(payload.total_record)
      state.overtime.loading = false
    },
    setNotificationQueue(state, payload) {
      state.notificationQueue = payload.list
      state.notificationQueueIndex = payload.index
    }
  },
  actions: {
    async loadNotification(context, payload) {
      let paramStatus = ''
      let paramModule = ''
      let paramSearch = ''
      if (payload !== undefined) {
        paramSearch = payload.keyword
        if (payload.document_status !== undefined) {
          if (payload.document_status !== null) {
            paramStatus = `&document_status=${payload.document_status}`
          }
        }
        if (payload.module !== undefined) {
          if (payload.module !== null) {
            paramModule = `&module=${payload.module}`
          }
        }
      }
      context.state.notification.loading = true
      const url = `${context.state.esanqua}notification/list?keyword=${paramSearch}&offset=0&limit=100&application_code=&channel=1${paramStatus}${paramModule}`
      await axios
        .get(url)
        .then((res) => {
          // CATATAN: endpoint ini ternyata mengembalikan ARRAY LANGSUNG
          // (tanpa pembungkus {status_code, data, total_record} seperti 7
          // endpoint approval-needs lainnya di file ini) — sesuai contoh
          // response yang diberikan. Kode di bawah menangani dua-duanya
          // (array polos ATAU dibungkus) supaya tetap aman kalau ternyata
          // backend suatu saat mengubah bentuknya jadi dibungkus juga.
          const isWrapped = !Array.isArray(res.data)
          if (isWrapped && res.data.status_code != '00') {
            context.commit('setNotificationResult', {
              data: [],
              total_record: 0,
              total_unread: 0
            })
            return
          }
          const rawList = isWrapped ? res.data.data : res.data
          return new Promise((resolve) => {
            setTimeout(() => {
              context.commit('setNotificationResult', {
                data: rawList || [],
                total_record: isWrapped
                  ? res.data.total_record
                  : (rawList || []).length,
                // `status === 0` berarti belum dibaca (dipastikan dari
                // action changeToRead: `if (payload.status === 0)`).
                total_unread: isWrapped
                  ? res.data.total_unread
                  : (rawList || []).filter((n) => n.status === 0).length
              })
              resolve()
            }, 500)
          })
        })
        .catch((err) => {
          console.log(err)
          context.commit('setNotificationResult', {
            data: [],
            total_record: 0,
            total_unread: 0
          })
        })
    },
    async loadPermissionApprovalNeeds(context, payload) {
      context.state.permission.loading = true
      // return await new Promise((resolve, reject) => {
      await axios
        .get(
          `${context.state.hrsApi}employee/permission/list?keyword=${payload}&offset=0&limit=100&mode=2&status_permission=1`
        )
        .then((res) => {
          if (res.data.status_code == '00') {
            // PENTING: setTimeout dibungkus Promise & di-`return` supaya ikut
            // masuk ke chain .then() yang di-`await` action ini. Sebelumnya
            // setTimeout dijadwalkan lalu ditinggal begitu saja, sehingga
            // `await loadPermissionApprovalNeeds(...)` di komponen resolve
            // ~500ms LEBIH CEPAT daripada commit yang men-set loading=false
            // dan mengisi `result` benar-benar jalan — inilah yang bikin
            // Promise.all() di Notifications.vue (dipakai tab "Semua")
            // resolve sebelum datanya benar-benar siap.
            return new Promise((resolve) => {
              setTimeout(() => {
                context.commit('setPermissionApprovalNeedsResult', res.data)
                resolve()
              }, 500)
            })
          } else {
            context.commit('setPermissionApprovalNeedsResult', {
              data: [],
              total_record: 0
            })
          }
        })
        .catch((err) => {
          console.log(err)
          context.commit('setPermissionApprovalNeedsResult', {
            data: [],
            total_record: 0
          })
          // reject(err)
        })
      // // })
    },
    async loadLeaveApprovalNeeds(context, payload) {
      context.state.leave.loading = true
      // return await new Promise((resolve, reject) => {
      await axios
        .get(
          `${context.state.hrsApi}employee/leave/list?keyword=${payload}&offset=0&limit=100&mode=2&status_leave=1&employee_id=`
        )
        .then((res) => {
          if (res.data.status_code == '00') {
            return new Promise((resolve) => {
              setTimeout(() => {
                context.commit('setLeaveApprovalNeedsResult', res.data)
                resolve()
              }, 500)
            })
          } else {
            context.commit('setLeaveApprovalNeedsResult', {
              data: [],
              total_record: 0
            })
          }
        })
        .catch((err) => {
          console.log(err)
          context.commit('setLeaveApprovalNeedsResult', {
            data: [],
            total_record: 0
          })
          // reject(err)
        })
      // })
    },
    async loadFpbApprovalNeeds(context, payload) {
      context.state.fpb.loading = true
      await axios
        .get(
          `${context.state.proc}fpb/list?keyword=${payload}&offset=0&limit=200&order_by=request_no&order_type=asc&status=1&inappnotif=true`
        )
        .then((res) => {
          if (res.data.status_code == '00') {
            return new Promise((resolve) => {
              setTimeout(() => {
                context.commit('setFpbApprovalNeedsResult', res.data)
                resolve()
              }, 500)
            })
          } else {
            context.commit('setFpbApprovalNeedsResult', {
              data: [],
              total_record: 0
            })
          }
        })
        .catch((err) => {
          console.log(err)
          context.commit('setFpbApprovalNeedsResult', {
            data: [],
            total_record: 0
          })
          // reject(err)
        })
    },
    async loadCaApprovalNeeds(context, payload) {
      context.state.ca.loading = true
      await axios
        .get(
          `${context.state.proc}payreq/list?keyword=${payload}&offset=0&limit=200&order_by=id&order_type=asc&status=1&inappnotif=true`
        )
        .then((res) => {
          if (res.data.status_code == '00') {
            return new Promise((resolve) => {
              setTimeout(() => {
                context.commit('setCaApprovalNeedsResult', res.data)
                resolve()
              }, 500)
            })
          } else {
            context.commit('setCaApprovalNeedsResult', {
              data: [],
              total_record: 0
            })
          }
        })
        .catch((err) => {
          console.log(err)
          context.commit('setCaApprovalNeedsResult', {
            data: [],
            total_record: 0
          })
          // reject(err)
        })
    },
    async loadPjcaApprovalNeeds(context, payload) {
      context.state.pjca.loading = true
      await axios
        .get(
          `${context.state.proc}pjca/list?keyword=${payload}&offset=0&limit=200&order_by=id&order_type=asc&status=1&inappnotif=true`
        )
        .then((res) => {
          if (res.data.status_code == '00') {
            return new Promise((resolve) => {
              setTimeout(() => {
                context.commit('setPjcaApprovalNeedsResult', res.data)
                resolve()
              }, 500)
            })
          } else {
            context.commit('setPjcaApprovalNeedsResult', {
              data: [],
              total_record: 0
            })
          }
        })
        .catch((err) => {
          console.log(err)
          context.commit('setPjcaApprovalNeedsResult', {
            data: [],
            total_record: 0
          })
          // reject(err)
        })
    },
    async loadRabApprovalNeeds(context, payload) {
      context.state.rab.loading = true
      await axios
        .get(
          `${context.state.proc}rab/list?keyword=${payload}&offset=0&limit=200&order_by=id&order_type=asc&status=1&inappnotif=true`
        )
        .then((res) => {
          if (res.data.status_code == '00') {
            return new Promise((resolve) => {
              setTimeout(() => {
                context.commit('setRabApprovalNeedsResult', res.data)
                resolve()
              }, 500)
            })
          } else {
            context.commit('setRabApprovalNeedsResult', {
              data: [],
              total_record: 0
            })
          }
        })
        .catch((err) => {
          console.log(err)
          context.commit('setRabApprovalNeedsResult', {
            data: [],
            total_record: 0
          })
          // reject(err)
        })
    },
    async loadOvertimeApprovalNeeds(context, payload) {
      context.state.overtime.loading = true
      await axios
        .get(
          `${context.state.hrsApi}employee/overtime_document/list?keyword=${payload}&offset=0&limit=100&mode=&status=1&company_id=`
        )
        .then((res) => {
          if (res.data.status_code == '00') {
            return new Promise((resolve) => {
              setTimeout(() => {
                context.commit('setOvertimeApprovalNeedsResult', res.data)
                resolve()
              }, 500)
            })
          } else {
            context.commit('setOvertimeApprovalNeedsResult', {
              data: [],
              total_record: 0
            })
          }
        })
        .catch((err) => {
          console.log(err)
          context.commit('setOvertimeApprovalNeedsResult', {
            data: [],
            total_record: 0
          })
          // reject(err)
        })
    },
    async setWebFcmToken(context) {
      const messaging = getMessaging()
      getToken(messaging, { vapidKey: process.env.VUE_APP_FCM_VAPID_KEY })
        .then((currentToken) => {
          if (currentToken) {
            // Send the token to your server and update the UI if necessary
            // console.log('FCM TOKEN>>>>>>', currentToken)
            axios
              .post(
                `${context.state.oAuth}user/fcm_token`,
                {
                  fcm_token_web: currentToken
                },
                {
                  headers: {
                    'x-token': store.state.auth.token,
                    'x-method': 'conventional',
                    'x-device-id': 'browser',
                    'x-device': 'web'
                  }
                }
              )
              .then(() => {})
              .catch((error) => {
                console.log(error)
              })
          } else {
            // Show permission request UI
            console.log(
              'No registration token available. Request permission to generate one.'
            )
            // ...
          }
        })
        .catch((err) => {
          console.log('An error occurred while retrieving token. ', err)
          // ...
        })
    },
    async changeToRead(context, payload) {
      console.log('changeToRead>>>', payload)
      if (payload.status === 0) {
        await axios
          .post(`${context.state.esanqua}notification/change_to_read`, {
            id: payload.id
          })
          .then((res) => {
            console.log('Change notif to read >>>>', res.data.status_code)
            return null
          })
          .catch((err) => {
            console.log('Change notif to read >>>>', err)
          })
      }
      return null
    },
    openNotification(context, payload) {
      const xData = payload.data
      const idx = payload.idx
      console.log('openNOtif>>>', xData, idx)
      context.dispatch('changeToRead', xData)
      let xRoute = ''
      if (xData.module === 'leave') {
        xRoute = `/hr/notification/leave/detail/${xData.document_id}?idx=${idx}`
      }
      if (xData.module === 'permission') {
        xRoute = `/hr/notification/permission/detail/${xData.document_id}?idx=${idx}`
      }
      if (xData.module === 'eCatalogue') {
        // this.$store.commit('setFpbId', xData.document_id)
        xRoute = `/e-catalogue/notification/fpb/${xData.document_id}?idx=${idx}`
      }
      if (xData.module === 'Cash Advance') {
        xRoute = `/e-catalogue/notification/payreq/detail/${xData.document_id}?idx=${idx}`
      }
      if (xData.module === 'pjca') {
        xRoute = `/e-catalogue/notification/pjca/detail/${xData.document_id}?idx=${idx}`
      }
      if (xData.module === 'rab') {
        xRoute = `/e-catalogue/notification/rab/detail/${xData.document_id}?idx=${idx}`
      }
      if (xData.module === 'overtime') {
        xRoute = `/hr/notification/overtime/document/detail/${xData.document_id}?idx=${idx}`
      }
      setTimeout(() => {
        router.push(xRoute)
      }, 100)
    }
  },
  getters: {
    getTotalMessage(state) {
      let total = 0
      // total = state.notification.totalUnread
      total =
        total +
        state.permission.totalData +
        state.leave.totalData +
        state.fpb.totalData +
        state.ca.totalData +
        state.pjca.totalData +
        state.rab.totalData +
        state.overtime.totalData

      return total
    },
    getNotification(state) {
      return state.notification
    },
    getPermissionApprovalNeeds(state) {
      return state.permission
    },
    getLeaveApprovalNeeds(state) {
      return state.leave
    },
    getFpbApprovalNeeds(state) {
      return state.fpb
    },
    getCaApprovalNeeds(state) {
      return state.ca
    },
    getPjcaApprovalNeeds(state) {
      return state.pjca
    },
    getRabApprovalNeeds(state) {
      return state.rab
    },
    getOvertimeApprovalNeeds(state) {
      return state.overtime
    },
    getNotificationQueue(state) {
      return {
        list: state.notificationQueue,
        index: state.notificationQueueIndex
      }
    }
  }
}
